<header class="header">
  <img
    class="cariloop-logo"
    src="assets/img/Cariloop-Logo-Black.svg"
    [alt]="'GENERAL.CARILOOP_LOGO_ALT' | translate"
  />
  <div lang-dropdown></div>
</header>
<div class="main-card">
  <div
    class="right-section"
    [ngClass]="{ 'right-section-padding-lg': isFirstStep }"
  >
    <div
      [ngClass]="{ 'show-progress': isFirstStep }"
      class="right-section__progress"
      role="progressbar"
    >
      <c-icon-button
        [materialIcon]="'arrow_back'"
        [accessibleText]="'INTRODUCTION.GO_BACK_ARIA' | translate"
        [showTextAsTooltip]="'false'"
        [size]="'large'"
        [colorTokenString]="'color-neutral-800'"
        [symbolType]="'rounded'"
        [iconFill]="false"
        (onClick)="onPrevious()"
      ></c-icon-button>
      <div class="bars" role="list">
        @for (item of [].constructor(6); track item; let i = $index) {
          <div
            class="bar"
            [ngClass]="i < currentSlide ? 'filled' : 'unfilled'"
          ></div>
        }
      </div>
    </div>
    <div
      class="right-section__text"
      [ngClass]="{ 'text-padding-extra': !isFirstStep }"
    >
      <h1 [ngClass]="isFirstStep ? 'heading-1-mixin' : 'heading-2-mixin'">
        {{ slides[currentSlide]?.title | translate }}
      </h1>
      <p
        [innerHTML]="slides[currentSlide]?.paragraph | translate"
        class="right-section__text-paragraph"
      ></p>
    </div>
    <div
      class="right-section__buttons"
      [ngClass]="{
        'button-margin-extra': !isFirstStep,
        'hide-element': !isTwoButtons,
      }"
    >
      <button class="black-button" (click)="onNext()">
        {{
          (!isFinalStep
            ? "INTRODUCTION.GET_STARTED_BUTTON"
            : "INTRODUCTION.CREATE_ACCOUNT"
          ) | translate
        }}
      </button>
      <span class="right-section__buttons-text"
        >{{ "INTRODUCTION.ACCOUNT" | translate
        }}<a
          href="/login"
          [attr.aria-label]="'INTRODUCTION.LOGIN_ARIA' | translate"
          >{{ "INTRODUCTION.LOG_IN" | translate }}</a
        ></span
      >
    </div>

    <button
      [ngClass]="{ 'hide-element': isTwoButtons }"
      class="transparent-button button-margin-extra"
      (click)="onNext()"
    >
      {{ "INTRODUCTION.NEXT_BUTTON" | translate }}
    </button>
  </div>
  <div class="left-section">
    <img
      [ngClass]="{ 'left-section__big-image': isFirstStep }"
      class="left-section__image"
      [src]="slides[currentSlide]?.imgSrc"
      [alt]="
        slides[currentSlide]?.alt ? slides[currentSlide]?.alt : ('' | translate)
      "
    />
  </div>
</div>
<button
  [ngClass]="{ 'hide-element': isTwoButtons }"
  (click)="onSkip()"
  class="skip-introduction"
>
  {{ "INTRODUCTION.SKIP" | translate }}
</button>
